export const API_ERROR = "api_failed";

export const RFQ_LIST_SR = "cq_rfq_list_SR";
export const RFQ_LIST_SR_SUCCESS = "cq_rfq_list_SR_success";

export const SELECT_CHANGEVALUE_SR = "cQ_Select_ChangeValue_SR";

export const RFQ_ROW_DATA_SR = "CQ_rfq_row_data_SR";
export const RFQ_ROW_DATA_SR_SUCCESS = "CQ_rfq_row_data_SR_success";

export const QUOTATION_ROW_DATA_SR = "Compare_Quotation_row_data_SR";
export const QUOTATION_ROW_DATA_SR_SUCCESS = "Compare_Quotation_row_data_SR_success";

export const QUOTATION_CHECKED_SR = "CQ_Quotation_Checked_sr";
export const APPROVED_QUANTITY_SR = "CQ_ApprovedQuantity_SR";
export const RESET_CELL_UPDATE = "CQ_reset_cell_Update";

export const SR_COMPARE_QUOTATION_ADD = "SR_Compare_Quotation_Add";

export const SR_COMPARE_QOUTATION_DATA = "SR_Compare_Quotation_data";
export const SR_COMPARE_QOUTATION_DATA_SUCCESS = "SR_Compare_Quotation_data_success";

export const SR_COMPARE_QOUTATION_LIST = "SR_Compare_Quotation_list";
export const SR_COMPARE_QOUTATION_LIST_SUCCESS = "SR_Compare_Quotation_list_success";

export const SET_SR_PARAMS = "CQ_set_SR_params";
export const FILTER_INPUT_CHANGEVALUE_SR = "CQ_Filter_input_ChangeValue_SR";
export const FILTER_SELECT_CHANGEVALUE_SR = "CQ_Filter_Select_ChangeValue_SR";

export const TOGGLE_SR_ITEM_MENU = "CQ_toggle_SR_item_menu";

export const PURCHASE_ORDER_SR_DATA = "Purchase_Order_SR_Data";

export const PURCHASE_ORDER_SR_LIST = "CQ_Purchase_Order_SR_list";
export const PURCHASE_ORDER_SR_LIST_SUCCESS = "CQ_Purchase_Order_SR_list_Success";
export const GENERATE_PURCHASE_ORDER_SR = "Generate_Purchase_Order_SR";
export const GENERATE_PURCHASE_ORDER_SR_RESPONSE =
  "Generate_Purchase_Order_SR_response";
export const SR_LIST_LAYOUT = "sr_CQ_list_layout";

export const FILTERS_SHOW_SR_RIGHT_SIDEBAR = "CQ_filter_show_SR_right_sidebar";
export const FILTERS_HIDE_SR_RIGHT_SIDEBAR = "CQ_filter_hide_SR_right_sidebar";
export const CLEAR_FILTER = "CQ_clear_filter";

export const SR_PO_MODEL_CLOSE = "CQ_SR_PO_model_close_1";
export const SR_PO_MODEL_OPEN = "CQ_SR_PO_model_open";

export const SR_PO_VEND_DATA = "CQ_po_vend_data";
export const INPUT_CHANGEVALUE_SR = "CQ_input_ChangeValue_SR";
export const RESET_SUBLOCATION = 'RESET_SUBLOCATION';
export const SR_PO_SELECT_CHANGEVALUE_SR = "CQ_SR_PO_Select_ChangeValue_SR";

